import React from 'react';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';

import store, { history } from '~/store';

import { AppRoutes } from '~/routes';
import ToastProvider from '~/components/Toast';

const App = () => {
  return (
    <Provider store={store}>
      <ConnectedRouter history={history}>
        <ToastProvider>
          <AppRoutes />
        </ToastProvider>
      </ConnectedRouter>
    </Provider>
  );
};

export default App;
